import React, {
  PropsWithChildren,
  ReactNode,
  useLayoutEffect,
  useRef,
  useState
} from "react"
import { interval } from "rxjs"

export const LoadingPaymentForm: React.FC<PropsWithChildren> = ({
  children
}) => {
  const messages = React.Children.toArray(children)
  const source = interval(3000)
  const indexx = useRef(0)
  const [currentMessage, setCurrentMessage] = useState<ReactNode | null>()

  useLayoutEffect(() => {
    indexx.current = 0
    setCurrentMessage(messages[indexx.current])

    const sups = source.subscribe(() => {
      if (indexx.current >= messages.length - 1) indexx.current = 0
      else indexx.current++
      setCurrentMessage(messages[indexx.current])
    })
    return () => {
      sups.unsubscribe()
    }
  }, [])

  return (
    <>
      {" "}
      <div className="max-w-[300px] md:max-w-[350px]">{currentMessage}</div>
    </>
  )
}
